module.exports = __webpack_public_path__ + "static/media/logo-chorinitia-1.290c3217.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/genericComponents/Navigation/Navigation/logo-chorinitia-1.jpg
// module id = 165
// module chunks = 0